import { format } from "date-fns";
import { constants } from "shared/constants";

export function formatDate(date?: Date): string {
    if (date) {
        return format(date, constants.queryStringDateFormat);
    }
    return constants.noValue;
}
